import tw, { styled } from "twin.macro";

const Select = styled.select(
  tw`block w-full rounded-md shadow-sm py-1.5 pl-3 pr-10 text-gray-900 border-0 ring-1 ring-inset ring-slate-900/10 sm:(text-sm leading-6) focus:(ring-2 ring-primary-800)`
);

export default Select;
